import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const projectMilestoneServices = {
  getProjectMilestoneData,
  addNewProjectMilestone,
  updateProjectMilestoneData,
  softDeleteRestoreProjectMilestone,
  deleteProjectMilestoneData,
};

async function addNewProjectMilestone(userData) {
  const response = await fetch(
    `${config.API_URL}addNewProjectMilestone`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateProjectMilestoneData(userData) {
  const response = await fetch(
    `${config.API_URL}updateProjectMilestone`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreProjectMilestone(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreProjectMilestone`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteProjectMilestoneData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteProjectMilestoneData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getProjectMilestoneData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL}getProjectMilestoneData/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL}getProjectMilestoneData/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}
